module.exports = ".categoria-gasto {\n  cursor: -webkit-grab;\n  cursor: grab; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/gastos/gastos.component.scss
// module id = ./src/app/gastos/gastos.component.scss
// module chunks = main